import { render, staticRenderFns } from "./expo-matching-table.vue?vue&type=template&id=e4e79502&scoped=true"
import script from "./expo-matching-table.vue?vue&type=script&lang=js"
export * from "./expo-matching-table.vue?vue&type=script&lang=js"
import style0 from "./expo-matching-table.vue?vue&type=style&index=0&id=e4e79502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e79502",
  null
  
)

export default component.exports